// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-container[data-v-c993397a] {\n  width: 100%;\n}\n.bj-formItemLabel[data-v-c993397a] {\n  max-width: 20em !important;\n}\ndiv:not(.bj-page) .bj-row .bj-col[data-v-c993397a] {\n  width: 49.33%;\n}", ""]);
// Exports
module.exports = exports;
